import { BRAND } from '../config/site';
import { LOGOS } from '../config/brand';

const BrandLogo = ({ footer = false }) => (
  <span
    data-testid={footer ? 'footer-logo' : 'header-logo'}
    className={`ks-brand-logo ${footer ? 'ks-brand-logo--footer' : 'ks-brand-logo--header'}`}
    aria-label={BRAND.fullName}
  >
    <span className="ks-brand-logo__symbol">
      <img src={LOGOS.symbol} alt="" aria-hidden="true" loading={footer ? 'lazy' : 'eager'} />
    </span>
    <span className="ks-brand-logo__type">
      <span className="ks-brand-logo__name">KINDSTONE</span>
      <span className="ks-brand-logo__tagline">Cleaning Services LLC</span>
    </span>
  </span>
);

export default BrandLogo;
